import React from 'react'
import DarkBlueLogo from "src/images/brand-darkblue.svg"
import TealLogo from "src/images/brand-teal.svg"
import MustardLogo from "src/images/brand-mustard.svg"
import DarkOrangeLogo from "src/images/brand-darkorange.svg"

const BrandLogo = ({ colour }) => {

    switch(colour) {
        case "darkblue" :
            return <DarkBlueLogo />
        case "teal" :
            return <TealLogo />
        case "mustard" :
            return <MustardLogo />
        case "darkorange" :
            return <DarkOrangeLogo />
        default :
            return <DarkBlueLogo />

    }
        
}

export default BrandLogo